/** `/demo/<screen>` shortcuts: where each goes and what state it sets up. */
import { DEMO_CODES } from './demoCodes';

const R = DEMO_CODES.running;

export interface DemoShortcut {
  path: string;
  to: string;
  label: string;
  group: 'Before the match' | 'In the match' | 'States';
  setup?: 'offline' | 'reconnecting' | 'onboarding' | 'since' | 'online';
}

export const DEMO_SHORTCUTS: DemoShortcut[] = [
  { path: '/create', to: '/new', label: 'Create match', group: 'Before the match' },
  {
    path: '/invite',
    to: `/m/${DEMO_CODES.lobby}/invite`,
    label: 'Share / invite',
    group: 'Before the match',
  },
  {
    path: '/join',
    to: `/m/${DEMO_CODES.lobby}/join`,
    label: 'Join + character creator',
    group: 'Before the match',
  },
  {
    path: '/late-join',
    to: `/m/${DEMO_CODES.pending}/join`,
    label: 'Late join (needs approval)',
    group: 'Before the match',
  },
  { path: '/lobby', to: `/m/${DEMO_CODES.lobby}/lobby`, label: 'Lobby', group: 'Before the match' },
  {
    path: '/pending',
    to: `/m/${DEMO_CODES.pending}/pending`,
    label: 'Waiting for approval',
    group: 'Before the match',
  },
  { path: '/map', to: `/m/${R}/map`, label: 'Map', group: 'In the match', setup: 'online' },
  { path: '/armies', to: `/m/${R}/armies`, label: 'Army list', group: 'In the match' },
  { path: '/army', to: `/m/${R}/armies/a-ash`, label: 'Army sheet (in battle)', group: 'In the match' },
  {
    path: '/orders',
    to: `/m/${R}/armies/a-ash/orders`,
    label: 'Queued orders builder',
    group: 'In the match',
  },
  {
    path: '/send',
    to: `/m/${R}/armies/a-ash/doctrine`,
    label: 'Send order (messenger / raven)',
    group: 'In the match',
  },
  { path: '/move', to: `/m/${R}/map?plan=a-outriders`, label: 'Move planning', group: 'In the match' },
  { path: '/split', to: `/m/${R}/armies/a-wolves/split`, label: 'Split army', group: 'In the match' },
  { path: '/recruit', to: `/m/${R}/armies/a-juno/recruit`, label: 'Recruit at keep', group: 'In the match' },
  { path: '/battle', to: `/m/${R}/battle/e17`, label: 'Battle', group: 'In the match' },
  { path: '/dispatch', to: `/m/${R}/dispatch`, label: 'Dawn Dispatch', group: 'In the match' },
  { path: '/intel', to: `/m/${R}/intel`, label: 'Intel', group: 'In the match' },
  { path: '/team', to: `/m/${R}/team`, label: 'Team & chat', group: 'In the match' },
  { path: '/approve', to: `/m/${R}/team?approve=jr4`, label: 'Join approval prompt', group: 'In the match' },
  { path: '/match-settings', to: `/m/${R}/settings`, label: 'Match settings', group: 'In the match' },
  {
    path: '/notifications',
    to: `/m/${R}/settings?prime=1`,
    label: 'Notification priming',
    group: 'In the match',
  },
  { path: '/results', to: `/m/${DEMO_CODES.finished}/results`, label: 'Results', group: 'In the match' },
  { path: '/onboarding', to: `/m/${R}/map`, label: 'First-run tips', group: 'States', setup: 'onboarding' },
  { path: '/since', to: `/m/${R}/map`, label: 'Since you last looked', group: 'States', setup: 'since' },
  {
    path: '/reconnecting',
    to: `/m/${R}/map`,
    label: 'Reconnecting banner',
    group: 'States',
    setup: 'reconnecting',
  },
  { path: '/offline', to: `/m/${R}/map`, label: 'Offline banner', group: 'States', setup: 'offline' },
  { path: '/settings', to: '/settings', label: 'App settings', group: 'States' },
];

export function findDemoShortcut(path: string): DemoShortcut | undefined {
  return DEMO_SHORTCUTS.find((s) => s.path === path && s.to !== path);
}
